/**
 * Пароль отправлен
 */
export const RESPONSE_PASSWORD_WAS_UPDATED = 'password_was_updated';

/**
 * Пользователь уже авторизован
 */
export const RESPONSE_USER_IS_AUTHORIZED = 'user_is_authorized';

/**
 * Пользователь еще не авторизован
 */
export const RESPONSE_USER_IS_UNAUTHORIZED = 'user_is_unauthorized';

/**
 * Регистрация завершена
 */
export const RESPONSE_REGISTRATION_COMPLETED = 'registration_completed';

/**
 * Форма регистрации валидна
 */
export const RESPONSE_REGISTRATION_FORM_IS_VALID = 'registration_form_is_valid';

/**
 * Код валидации отправлен
 */
export const RESPONSE_SECURITY_CODE_WAS_SENT = 'security_code_was_sent';

/**
 * Код валидации верен
 */
export const RESPONSE_SECURITY_CODE_IS_VALID = 'security_code_is_valid';

/**
 * Профиль пользователя обновлен
 */
export const RESPONSE_USER_PROFILE_UPDATED = 'user_profile_updated';

/**
 * Профиль пользователя получен
 */
export const RESPONSE_USER_PROFILE_FETCHED = 'user_profile_fetched';

/**
 * Номер телефона подтвержден
 */
export const RESPONSE_PHONE_NUMBER_CONFIRMED = 'phone_number_confirmed';

/**
 * Email подтвержден
 */
export const RESPONSE_EMAIL_CONFIRMED = 'email_confirmed';

/**
 * Компания активна
 */
export const RESPONSE_COMPANY_IS_ACTIVE = 'company_is_active';

/**
 * Компания зарегистрирована
 */
export const RESPONSE_COMPANY_IS_REGISTERED = 'company_is_registered';
